<template>
    <MainLayout v-if="authenticated || ('5' == roleId)" v-loading.fullscreen.lock="loading.global">
        <App></App>
    </MainLayout>
    <LoginLayout v-else v-loading.fullscreen.lock="loading.global">
        <router-view></router-view>
    </LoginLayout>

</template>

<script>
    import { mapActions, mapState, createNamespacedHelpers } from 'vuex';
    import MainLayout from './layouts/MainLayout';
    import LoginLayout from './layouts/LoginLayout';
    import App from './App';

    const { mapGetters, mapMutations } = createNamespacedHelpers('auth')
    export default {
        name: 'authorized',
        components: {LoginLayout, App, MainLayout,},
        computed: {
            ...mapState(['loading']),
            ...mapGetters(['authenticated']),
            ...mapState('auth', ['roleId'])
        },
        methods:{
            ...mapMutations(['reloadAuth']),
            ...mapActions('auth', { initAnon: 'anonInit' }),
        },
        async created() {
            if (['', '5'].includes(this.roleId)) {
                await this.initAnon(this.login);
            } else {
                this.reloadAuth();
            }
        }
    }
</script>

<style>
    html, body{
        margin: 0;
        padding: 0;
        height: 100%;
    }

    input, label, span, div, h1, h2, h3, button, textarea {
        font-family: 'Noto Sans TC', sans-serif !important;
    }

    .dcw-font-MingLiuCSS.dcw-hasGaiji{
        font-family: 'MingLiu1' !important;
    }
</style>


